import { updateDialog, closeDialog } from '@Containers/Dialogs/DialogsActions';

import { typeOfRcsSupplierInfoDialog } from './RcsSupplierInfoDialogConstants';

import { fetchSupplierInfo } from '../RcsSupplierInfoActions';

export function open(crn, databaseId, payload) {
  return async (dispatch) => {
    const id = databaseId + crn;
    const openAction = updateDialog({
      id,
      crn,
      databaseId,
      ...payload,
      movable: false,
      dialogType: typeOfRcsSupplierInfoDialog,
      backdrop: true,
    });

    dispatch(openAction);

    try {
      await dispatch(fetchSupplierInfo(crn, databaseId));
    } catch (e) {
      dispatch(closeDialog({ id }));
      Logger.error(e);
    }
  };
}
